import { EN } from 'config/localization/languages'
import { LanguageContext } from './Provider'
import { translate } from './helpers'
import { ContextApi, ContextData } from './types'

const DUMMY_LANG_MAP = new Map()
const DISABLED_I18N_CONTEXT_VALUE: ContextApi = {
  isFetching: false,
  currentLanguage: EN,
  setLanguage: () => undefined,
  t: (key: string, data: ContextData) => translate(DUMMY_LANG_MAP, EN, key, data),
}

const I18nDisabledProvider: React.FC = ({ children }) => {
  return <LanguageContext.Provider value={DISABLED_I18N_CONTEXT_VALUE}>{children}</LanguageContext.Provider>
}

export default I18nDisabledProvider
